export default __webpack_public_path__ + "static/media/play_store.3694cb4d.png";